<div class="modal-overlay" *ngIf="modalAberta" (click)="!loading && fechar()">
  <div class="box-nova-pasta" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-8">
        <h6 class="fw-bold"><i class="fa fa-folder-open"></i> Nova pasta</h6>
      </div>
      <div class="col-md-4 text-end">
        <button type="button" class="btn-close" (click)="fechar()" aria-label="Close" [disabled]="loading"></button>
      </div>
    </div>
    <hr>
    <form [formGroup]="formPasta">
      <div class="form-group mb-3">
        <label for="descricao">Descrição</label>
        <input id="descricao" class="form-control" type="text" formControlName="descricao" [disabled]="loading" />
      </div>
      <div class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-light" (click)="fechar()" [disabled]="loading">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="salvar()" [disabled]="loading">
          <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ loading ? 'Salvando...' : 'Salvar' }}
        </button>
      </div>
    </form>
  </div>
</div>
